import ArticleHero from './RootElements/ArticleHero';
import DividerLine from './RootElements/DividerLine';
import HtmlImageBlock from './RootElements/HtmlImageBlock';
import SingleLink from './RootElements/SingleLink';

const contentElements = {
  'HTML IMAGE BLOCK': HtmlImageBlock,
  'DIVIDER LINE': DividerLine,
  'SINGLE LINK': SingleLink,
  'Article Hero': ArticleHero,
};

export default contentElements;
